export default __webpack_public_path__ + "static/media/add.cb024136.svg";